export default __webpack_public_path__ + "static/media/Colourful_Me_Min.ecceaf00.jpg";